import "../../css/chat/chatwindow.css";
import 'react-block-ui/style.css';

import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { addMessage } from '../../redux/interactionsSlice'
import store from "../../redux/store";
import ChatsService from '../../controllers/ChatController';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import BlockUi from 'react-block-ui';
import { withTranslation } from "react-i18next";
import Emojis from './emojis';
import { addHistoryMessages, setSearchText, closeConversation } from '../../redux/interactionsSlice';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Faq from './faq';
import Messages from "./messages";
import ChatControlsMenu from "./chatcontrolsmenu";
import AiResponse from "./airesponse";
import AiOpts from "./aiopts";
import i18next from 'src/i18next';
import Toastr from 'src/components/utils/toastr';
import { seconds2MS } from "../utils/utils";

const CHANNEL_OPTS = {
    "whatsapp": {
        "maxLength": 4096,
        "accept": ".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .mp4, .mp3, .ogg, .aac, .amr",
        "maxSize": 16 * 1024 * 1024
    },
    "telegram": {
        "maxLength": 4096,
        "accept": ".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .zip, .rar, .mp4, .mkv, .avi, .mov, .mp3, .wav, .ogg",
        "maxSize": 20 * 1024 * 1024
    },
    "facebook": {
        "maxLength": 2000,
        "accept": ".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .mp4, .mp3, .ogg, .aac",
        "maxSize": 25 * 1024 * 1024
    },
    "instagram": {
        "maxLength": 1000,
        "accept": ".jpg, .jpeg, .png, .mp4, .avi, .mov, .ogg, .webm, .aac, .m4a, .wav, .gif",
        "maxSize": 25 * 1024 * 1024
    }
};

class Conversation extends Component {

    constructor(props) {

        super(props)

        let sizes = {
            "maxLength": 10000,
            "accept": ".jpg, .jpeg, .png, .xls, .csv, .xlsx, .pdf, .doc, .docx, .mp4, .mp3, .mpeg, .wav",
            "maxSize": 25 * 1024 * 1024
        };

        if (CHANNEL_OPTS[props.interaction.channel])
            sizes = CHANNEL_OPTS[props.interaction.channel];

        this.state = {
            input_value: '',
            showEmojis: false,
            loading: false,
            showOutgoingChats: false,
            showInteralChat: false,
            loadingHistory: false,
            showLoadHistory: true,
            showFaq: false,
            searchText: "",
            searchTimeoutId: null,
            scrollPosition: -1,
            scrollTimeoutId: null,
            view: "chat",
            showTransfer: false,
            showSendEmail: false,
            showButtons: false,
            showAiResponse: false,
            showAiOps: false,
            isRecording: false,
            recorder: null,
            time: "00:00",
            seconds: 0,
            maxLength: sizes.maxLength,
            accept: sizes.accept,
            maxSize: sizes.maxSize
        }

        this.timer = null;
        this.divContent = createRef();
        this.lastMessage = createRef();
        this.inputFile = createRef();
        this.sendButton = createRef();
        this.scrollUpRef = createRef();

        this.messagesRefs = [];

        this.handleInput = this.handleInput.bind(this);
        this.send = this.send.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.toggleOugoingChatsModal = this.toggleOugoingChatsModal.bind(this);
        this.setInputValue = this.setInputValue.bind(this);
        this.handleVideoCall = this.handleVideoCall.bind(this);
        this.setSearchText = this.setSearchText.bind(this);
        this.scrollToPrevious = this.scrollToPrevious.bind(this);
        this.scrollToNext = this.scrollToNext.bind(this);
        this.loadHistory = this.loadHistory.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.toggleButtons = this.toggleButtons.bind(this);
        this.addMessageRef = this.addMessageRef.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.previewFile = this.previewFile.bind(this);
        this.toggleAiOpts = this.toggleAiOpts.bind(this);
        this.toggleAiResponse = this.toggleAiResponse.bind(this);
        this.generateResponse = this.generateResponse.bind(this);
        this.startRecording = this.startRecording.bind(this);
        this.stopRecording = this.stopRecording.bind(this);
        this.count = this.count.bind(this);

        this.emojiInvokerRef = React.createRef();
        this.optionInvoker = React.createRef();
        this.aiOptsInvoker = React.createRef();
        this.toastrRef = React.createRef();

    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.interaction !== null && this.props.interaction.id != null) {

            if (prevProps.interaction === null || (prevProps.interaction.id !== this.props.interaction.id)) {

                let sizes = {
                    "maxLength": 10_000,
                    "accept": ".jpg, .jpeg, .png, .xls, .csv, .xlsx, .pdf, .doc, .docx, .mp4, .mp3, .mpeg, .wav",
                    "maxSize": 25 * 1024 * 1024
                };

                if (CHANNEL_OPTS[this.props.interaction.channel])
                    sizes = CHANNEL_OPTS[this.props.interaction.channel];

                this.setState({
                    maxLength: sizes.maxLength,
                    accept: sizes.accept,
                    maxSize: sizes.maxSize
                })
            }
        }
        if (!this.state.searchText) {
            setTimeout(() => {
                this.scrollToBottom();
            }, 500);
        }


    }

    scrollToBottom = () => {
        if (!this.state.loadingHistory && this.lastMessage.current)
            this.lastMessage.current.scrollIntoView();

    }

    setLoading(value) {
        this.setState({
            loading: value
        })
    }

    send = () => {

        if ((this.state.input_value && this.state.input_value !== '') || this.inputFile.current.files.length > 0) {

            let user = JSON.parse(localStorage.getItem("fc-logged")),
                message = {
                    id: this.props.interaction.id,
                    mediaType: "text",
                    media: false,
                    text: this.state.input_value,
                    date: new Date().toISOString(),
                    type: "A",
                    pin: user.userId,
                    from: user.userId,
                    ogText: null
                };

            if (this.inputFile.current.files.length > 0) {

                this.setLoading(true);

                let file = this.inputFile.current.files[0];
                ChatsService.uploadFile(file, data => {
                    message.mediaType = data.mediaType;
                    message.url = data.url;
                    message.media = true;
                    message.fileName = file.name;
                    store.dispatch(addMessage(message));
                    ChatsService.sendMessage(message);
                    this.setLoading(false);
                    this.setState({ input_value: '' });
                    this.divContent.current.textContent = "";
                    this.inputFile.current.value = "";
                });

            } else {
                if (this.props.interaction.aiTranslation) {
                    this.setLoading(true);
                    ChatsService.translate({ guid: this.props.interaction.guid, text: message.text }, data => {
                        if (data) {
                            this.setState({ input_value: '' });
                            this.divContent.current.textContent = "";
                            store.dispatch(addMessage({ ...message }));

                            message.ogText = message.text;
                            message.text = data + "";

                            ChatsService.sendMessage(message);
                            this.setLoading(false);
                        }
                        else {
                            this.setState({ input_value: '' });
                            this.divContent.current.textContent = "";
                            store.dispatch(addMessage(message));
                            ChatsService.sendMessage(message);
                            this.setLoading(false);
                        }
                    }, error => {

                    });
                } else {
                    this.setState({ input_value: '' });
                    this.divContent.current.textContent = "";
                    store.dispatch(addMessage(message));
                    ChatsService.sendMessage(message);
                }
            }
        }
    }

    handleInput = e => {
        e.preventDefault();
        let text = e.target.textContent;
        if (text.length > this.state.maxLength) {
            text = text.slice(0, this.state.maxLength);
            this.divContent.current.textContent = text;
            let el = this.divContent.current;
            const range = document.createRange();
            const sel = window.getSelection();
            range.selectNodeContents(el);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        }

        this.setState({
            input_value: text
        });
    }

    keyPress = e => {
        if (e.charCode === 13 && !e.shiftKey) {
            this.send();
        }
    }

    emojiClick = (e, emojiObj) => {
        e.preventDefault();
        let text = this.state.input_value + emojiObj.emoji;
        this.divContent.current.textContent = text;
        this.setState({
            input_value: text
        });
    }

    handleEmojisClick = (e) => {
        if (e)
            e.preventDefault();
        let showEmojis = !this.state.showEmojis;
        this.setState({
            showEmojis: showEmojis
        });
    }

    handleAttachClick = e => {
        e.preventDefault();
        this.inputFile.current.click();
        this.setState({ showButtons: !this.state.showButtons });
    }

    handleFileChange = e => {

        e.preventDefault();

        if (this.inputFile.current.files.length > 0) {
            let file = this.inputFile.current.files[0],
                text = file.name;

            if (file.size > this.state.maxSize) {
                this.inputFile.current.value = "";
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("filetoolarge"));
                this.toastrRef.current.show();

            } else {
                let element = this.divContent.current;
                this.previewFile(file, element, text);

                this.setState({
                    input_value: "🧾" + text
                });
            }
        }
    }

    previewFile(file, element, text) {
        let image = ["jpg", "jpeg", "png"];
        let video = ["mp4", "mkv", "mpeg", "avi"];
        let audio = ["mp3", "wav", "webm"];
        //let doc = ["csv", "xlsx", "doc", "docx", "txt"];
        let fileExt = file.name.split('.').pop().toLowerCase();
        var reader = new FileReader();

        reader.onload = function (e) {

            if (image.includes(fileExt)) {
                let img = document.createElement('img');
                img.style.width = "500px"
                img.style.display = "block";
                img.src = e.target.result;
                element.appendChild(img);
            }

            if (video.includes(fileExt)) {
                let vid = document.createElement('video');
                vid.style.width = "500px"
                vid.style.display = "block";
                vid.src = e.target.result;
                vid.controls = true;
                element.appendChild(vid);
            }

            if (audio.includes(fileExt)) {
                let aud = document.createElement('audio');
                aud.style.width = "500px"
                aud.style.display = "block";
                aud.src = e.target.result;
                aud.controls = true;
                element.appendChild(aud);
            }

            if (fileExt === "pdf") {
                let pdf = document.createElement('embed');
                pdf.style.width = "500px"
                pdf.style.display = "block";
                pdf.src = e.target.result;
                element.appendChild(pdf);
            }

            element.style.display = "inline-block"
            element.append("🧾" + text);
        }

        reader.readAsDataURL(file);

    }

    toggleOugoingChatsModal = e => {
        //e.preventDefault();
        this.setState({ showOutgoingChats: !this.state.showOutgoingChats });
    }

    toggleInternalChatModal = e => {
        //e.preventDefault();
        this.setState({ showInteralChat: !this.state.showInteralChat });
    }

    loadMessages = e => {
        e.preventDefault();
        this.loadHistory(10);

    }

    loadHistory = (take, callBack) => {
        this.setState({
            loadingHistory: true
        });
        let skip = this.props.interaction.messages.filter(x => x.isHistory).length;

        ChatsService.loadMessages(this.props.interaction.id, skip, take, x => {
            if (x.data != null && x.data.length > 0) {
                x.data.forEach(y => {
                    y.isHistory = true;
                });

                var history = x.data;
                history.reverse();
                this.props.addHistoryMessages({ id: this.props.interaction.id, messages: history });
            } else {
                this.setState({
                    showLoadHistory: false
                });
            }

            if (callBack)
                callBack();
        });
    }

    toggleFaqModal = e => {
        if (e)
            e.preventDefault();
        this.setState({
            showFaq: !this.state.showFaq
        });
    }

    setInputValue = (value) => {
        let text = value,
            position = this.state.scrollPosition;

        if (text.length > this.state.maxLength) {
            text = text.slice(0, this.state.maxLength);
        }

        this.divContent.current.textContent = text;

        if (this.state.input_value !== text)
            position = -1;

        this.setState({
            input_value: text,
            scrollPosition: position
        });
    }

    handleVideoCall = e => {
        e.preventDefault();
        let user = JSON.parse(localStorage.getItem("fc-logged"));

        this.setLoading(true);

        ChatsService.getFidelityUrl(user.userId, x => {
            let caller = this.props.interaction.name;

            switch (this.props.interaction.channel) {
                case "fidelity":
                    caller = this.props.interaction.email;
                    break;
                case "whatsapp":
                    caller = this.props.interaction.phone;
                    break;
                default:
                    caller = this.props.interaction.id;
                    break;
            }

            let called = user.shortExtension,
                callinfo = this.props.interaction.guid,
                message = `https://${x.data}/FidelityWebRTC/?caller=${caller}&called=webrtcvideo:${called}&callinfo=${callinfo}&timestamp=${new Date().toISOString()}`,
                url = encodeURIComponent(message);


            ChatsService.getShortUrl(url, y => {

                let text = "",
                    resUrl = message;
                if (y != null) {
                    resUrl = y.data.url;
                }

                text = (this.props.interaction.videoCallMessage ?? "") + "\n" + resUrl;

                this.divContent.current.textContent = text;

                this.setState({
                    input_value: text
                }, z => {
                    this.send();
                    this.setLoading(false);
                });
            })
        });
        this.setState({ showButtons: !this.state.showButtons });
    }

    setSearchText(e) {
        e.preventDefault();

        clearTimeout(this.state.searchTimeoutId);

        let timeoutId = setTimeout(z => {
            this.props.setSearchText(e.target.value);

            // ! TODO: is too slow need to provide a better solution
            ChatsService.getLastOcurrenceOfString(this.props.interaction.id, this.state.searchText, x => {
                if (x.data > -1) {
                    let skip = this.props.interaction.messages.filter(x => x.isHistory).length;
                    let take = x.data - skip;
                    if (take > 0)
                        this.loadHistory(take, x => { });
                }

            });

        }, 100);

        this.setState({
            searchTimeoutId: timeoutId,
            searchText: e.target.value,
            scrollPosition: -1
        });
    }

    scrollToPrevious(e) {
        e.preventDefault();

        if (this.state.searchText) {
            let markedMessages = this.messagesRefs.filter(x => x.current != null && x.current.innerHTML.indexOf("<mark>") > -1).map(x => x.current);
            let position = markedMessages.length - 1;

            if (markedMessages.length > 0) {

                if (this.state.scrollPosition === -1) {
                    this.setState({
                        scrollPosition: position
                    });

                } else {

                    if (this.state.scrollPosition > 0) {
                        position = this.state.scrollPosition;
                        position -= 1;
                    }
                    this.setState({
                        scrollPosition: position
                    });
                }

                markedMessages[position].scrollIntoView();

            }
        }
    }

    scrollToNext(e) {
        e.preventDefault();

        if (this.state.searchText) {
            let markedMessages = this.messagesRefs.filter(x => x.current != null && x.current.innerHTML.indexOf("<mark>") > -1).map(x => x.current);
            let position = 0;

            if (markedMessages.length > 0) {

                if (this.state.scrollPosition === (markedMessages.length - 1)) {
                    this.setState({
                        scrollPosition: position
                    });

                } else {

                    if (this.state.scrollPosition < markedMessages.length) {
                        position = this.state.scrollPosition;
                        position += 1;
                    }
                    this.setState({
                        scrollPosition: position
                    });
                }

                markedMessages[position].scrollIntoView();

            }
        }
    }

    handleDrop = e => {

        e.stopPropagation();
        e.preventDefault();

        let files = e.dataTransfer.files;

        if (files !== null && files.length > 0) {

            let dataTransfer = new DataTransfer(),
                file = files[0],
                text = file.name;

            dataTransfer.items.add(file)
            this.inputFile.current.files = dataTransfer.files;

            let element = this.divContent.current;
            this.previewFile(file, element, text);
            this.setState({
                input_value: "🧾" + text
            });

        } else {
            let text = e.dataTransfer.getData("text");
            this.setState({ input_value: text });
            this.divContent.current.textContent = text;
        }
    }

    handlePaste = e => {
        e.stopPropagation();
        e.preventDefault();

        let clipboardPayload = (e.originalEvent || e).clipboardData.items;
        if (!clipboardPayload.length || clipboardPayload.length === 0) return false;

        let files = (e.originalEvent || e).clipboardData.files;

        if (files !== null && files.length > 0) {
            let dataTransfer = new DataTransfer(),
                file = files[0],
                text = file.name;

            dataTransfer.items.add(file)
            this.inputFile.current.files = dataTransfer.files;

            let element = this.divContent.current;
            this.previewFile(file, element, text);

            this.setState({
                input_value: "🧾" + text
            });

        } else {
            let text = this.state.input_value + (e.originalEvent || e).clipboardData.getData("Text");
            this.setState({ input_value: text });
            this.divContent.current.textContent = text;
        }
    }

    addMessageRef(ref) {
        this.messagesRefs.push(ref);
    }

    toggleButtons = e => {
        //e.preventDefault();
        this.setState({ showButtons: !this.state.showButtons });
    }

    removeFile = e => {
        //e.preventDefault();
        this.setState({ input_value: '' });
        this.divContent.current.textContent = "";
        this.inputFile.current.value = "";
    }

    toggleAiResponse = e => {
        if (e)
            e.preventDefault();

        this.setState({
            showAiResponse: !this.state.showAiResponse
        });
    }

    toggleAiOpts = e => {
        if (e)
            e.preventDefault();

        this.setState({
            showAiOps: !this.state.showAiOps
        });
    }

    generateResponse(type, size) {
        let data = {
            guid: this.props.interaction.guid,
            language: i18next.language || window.localStorage.i18nextLng,
            size: size,
            type: type,
            draft: this.state.input_value
        };
        this.setLoading(true);
        this.toggleAiOpts();
        ChatsService.getResponse(data, res => {
            if (res !== null && res.trim() !== "") {
                this.setInputValue(res);
            } else {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("error"));
                this.toastrRef.current.show();
            }


            this.setLoading(false);

        })

    }

    startRecording = async () => {



        this.timer = setInterval(this.count, 1000);

        let stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        let recorder = new MediaRecorder(stream);
        let audioChunks = [];

        this.setState({
            isRecording: !this.state.isRecording,
            recorder: recorder
        });

        recorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
                audioChunks.push(event.data);
            }
        };

        recorder.onstop = () => {
            const mimeToExt = {
                "audio/webm": ".webm",
                "audio/wav": ".wav",
                "audio/mp3": ".mp3",
                "audio/mpeg": ".mp3",
                "audio/ogg": ".ogg",
            };

            const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
            const fileName = "recording" + (mimeToExt[audioBlob.type] || "");
            const audioFile = new File([audioBlob], fileName, { type: audioBlob.type });
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(audioFile);
            this.inputFile.current.files = dataTransfer.files;
            let element = this.divContent.current;
            let file = dataTransfer.files[0];
            this.previewFile(file, element, fileName);

            this.setState({
                input_value: "🧾" + fileName
            });

        };

        recorder.start();


    }

    stopRecording = () => {

        if (this.state.recorder && this.state.recorder.state !== "inactive") {
            clearInterval(this.timer);
            this.state.recorder.stop();
            this.state.recorder.stream.getTracks().forEach((track) => track.stop());

            this.setState({
                isRecording: !this.state.isRecording,
                recorder: this.state.recorder,
                seconds: 0,
                time: "00:00"
            });

        }
    }

    count() {

        let seconds = this.state.seconds + 1,
            result = seconds2MS(Math.abs(seconds))

        this.setState({
            time: result,
            seconds: parseInt(seconds)
        });
    }

    render() {

        return (


            <>
                <button className='load-messages btn btn-light'
                    onClick={this.loadMessages} style={this.props.interaction !== null && this.props.interaction.hasHistory && this.state.showLoadHistory ?
                        { display: "inline-block" } : { display: "none" }}>{this.props.t("loadmessages")} </button>
                {
                    (this.props.interaction && this.props.showSearch) &&
                    <div className='search-container'>
                        <FontAwesomeIcon className='searchiconchat' icon={faMagnifyingGlass} />
                        <Form.Control className='searchinput' type="text" placeholder={this.props.t("search")} value={this.state.searchText} onChange={this.setSearchText} ></Form.Control>
                        <Button ref={this.scrollUpRef} className='scroll-top' onClick={this.scrollToPrevious}>  <FontAwesomeIcon icon={faChevronUp} /></Button>
                        <Button className='scroll-bottom' onClick={this.scrollToNext}>  <FontAwesomeIcon icon={faChevronDown} /></Button>
                    </div>
                }
                <Messages interaction={this.props.interaction} addMessageRef={this.addMessageRef} lastMessage={this.lastMessage} />

                {
                    this.props.interaction && !this.props.interaction.closed && !this.props.interaction.onHold &&

                    <BlockUi tag="div" blocking={this.state.loading} message={this.props.t("pleasewait")} color="#009ef7">
                        <div className="chat-controls">
                            <Row>
                                <Col xs={3} xxl={2} style={{ position: "relative", "top": "5px" }}>

                                    <Button size="sm" ref={this.emojiInvokerRef} variant="light-primary" className='chat-controls position-relative' onClick={this.handleEmojisClick}><FontAwesomeIcon icon={duotone("face-smile")} /></Button>

                                    {
                                        this.props.interaction.channel !== "internal" &&
                                        <Button size="sm" ref={this.optionInvoker} variant="light-primary" className='chat-controls' onClick={this.toggleButtons}><FontAwesomeIcon icon={duotone("plus")} /></Button>
                                    }

                                    {
                                        this.props.aiEnabled &&
                                        <OverlayTrigger
                                            placement="left"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={<Tooltip style={{ position: "fixed" }}>
                                                {this.props.t("aiautoanswer")}
                                            </Tooltip>}>
                                            <Button size="sm" ref={this.aiOptsInvoker} variant="light-primary" className='chat-controls position-relative' onClick={this.toggleAiOpts}><FontAwesomeIcon icon={duotone("sparkles")} /></Button>
                                        </OverlayTrigger>

                                    }

                                </Col>
                                <Col xs={6} xxl={8}>

                                    <div className="position-relative" style={{ width: "105%", height: "100%", right: "40px" }}>

                                        {
                                            (this.inputFile.current != null && this.inputFile.current.files.length > 0) &&
                                            <div style={{ position: "relative", zIndex: 1, top: "5px" }}>
                                                <OverlayTrigger
                                                    placement="left"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={<Tooltip style={{ position: "fixed" }}>
                                                        {this.props.t("cancel")}
                                                    </Tooltip>}>
                                                    <Button variant="light-danger float-end" size="sm" onClick={this.removeFile}><FontAwesomeIcon icon={solid("xmark")} /></Button>
                                                </OverlayTrigger>
                                            </div>
                                        }

                                        <div placeholder={this.props.t("writeamessage")} ref={this.divContent} onInput={this.handleInput} onKeyPress={this.keyPress}
                                            contentEditable={!this.state.isRecording} className='inputtext float-start' type="text" suppressContentEditableWarning={true}
                                            onDrop={this.handleDrop} onPaste={this.handlePaste}
                                        >
                                            {
                                                this.state.isRecording &&
                                                <p style={{ "position": "absolute", "top": "10px", "left": "15px" }}>
                                                    <FontAwesomeIcon size="lg" icon={duotone("microphone")} className="text-danger animation-blink" /> <span style={{ "padding": "5px" }} className="text-primary ">{this.state.time}</span>
                                                </p>
                                            }

                                        </div>
                                        <input ref={this.inputFile} onChange={this.handleFileChange} type={'file'} accept={this.state.accept} style={{ display: "none" }} />
                                    </div>

                                </Col>
                                <Col xs={3} xxl={2}>

                                    <Button variant="primary" size="md" className="float-end" onClick={this.send} ref={this.sendButton}><FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}</Button>
                                    {
                                        !this.state.isRecording &&
                                        <Button variant="light-primary" size="md" className='chat-controls position-relative "float-end' onClick={this.startRecording}><FontAwesomeIcon icon={duotone("microphone")} /></Button>
                                    }

                                    {
                                        this.state.isRecording &&

                                        <Button variant="light-primary" size="md" className='chat-controls position-relative "float-end' onClick={this.stopRecording}><FontAwesomeIcon icon={duotone("circle-stop")} /></Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {
                                        this.props.interaction.track.location &&
                                        <a className="location" href={this.props.interaction.track.location} target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={duotone("location-pin")} /> {this.props.interaction.track.location}</a>
                                    }
                                </Col>
                            </Row>
                            <ChatControlsMenu invoker={this.optionInvoker} toggleButtons={this.toggleButtons} showButtons={this.state.showButtons} toggleFaqModal={this.toggleFaqModal} handleAttachClick={this.handleAttachClick} handleVideoCall={this.handleVideoCall}></ChatControlsMenu>
                            <AiOpts invoker={this.aiOptsInvoker} toggleAiOpts={this.toggleAiOpts} showAiOps={this.state.showAiOps} toggleAiResponse={this.toggleAiResponse} generateResponse={this.generateResponse}></AiOpts>
                        </div>
                    </BlockUi >
                }
                <Faq show={this.state.showFaq} toggleModal={this.toggleFaqModal} setInputValue={this.setInputValue} conversationId={this.props.interaction != null ? this.props.interaction.id : -1}></Faq>
                {
                    (this.state.showEmojis) &&
                    <Emojis invoker={this.emojiInvokerRef} showEmojis={this.state.showEmojis} emojiClick={this.emojiClick} handleEmojisClick={this.handleEmojisClick} />
                }

                <AiResponse show={this.state.showAiResponse} toggleModal={this.toggleAiResponse} inputValue={this.state.input_value} setInputValue={this.setInputValue}></AiResponse>
                <Toastr ref={this.toastrRef} />
            </>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        chatUrl: state.parameters.chatUrl,
        LOADING_TYPE: state.parameters.LOADING_TYPE,
        agentName: state.agent.name,
        userId: state.agent.userId,
        showSearch: state.interaction.showSearch,
        interaction: state.interaction.current,
        aiEnabled: state.parameters.aiEnabled
    };
};

export default compose(connect(mapStateToProps, { addHistoryMessages, setSearchText, closeConversation }), withTranslation())(Conversation);